import React, { useContext } from 'react';
import classNames from 'classnames';
import EnterpriseForm from '../../../../components/EnterpriseForm';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button } from 'ncoded-component-library';
import EnterpriseContext from 'router/subrouters/Dash/subrouters/private/subrouters/Enterprise/providers/Enterprise/Enterprise.context';

import './EditEnterprise.styles.scss';
import './EditEnterprise.styles.responsive.scss';

type EditEnterpriseProps = {
  className?: string;
};

const EditEnterprise: React.FC<EditEnterpriseProps> = (props) => {
  const { className } = props;

  const { enterprise, updateEnterprise } = useContext(EnterpriseContext);

  const classes = classNames('edit-enterprise', className);

  const { t } = useTranslation();

  const navigate = useNavigate();

  return (
    <div className={classes}>
      <div className="edit-enterprise__heading">
        <h1>{t('editAnEnterprise')}</h1>
        <Button onClick={() => navigate('manage-people')}>
          {t('managePeople')}
        </Button>
      </div>

      <EnterpriseForm
        enterprise={enterprise}
        updateEnterprise={updateEnterprise}
      />
    </div>
  );
};

export default EditEnterprise;
